<template>
    <div class="container">
        <div class="row">
            <div class="col-md-6">
                <h2>View</h2>
                <h4>Retailer Log</h4>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-md-2">
                <span class="font-weight-bold">Date: </span>
            </div>
            <div class="col-md-6">
                <span>{{ this.date }}</span>
            </div>
        </div>
        <div class="row mt-2">
            <div class="col-md-2">
                <span class="font-weight-bold">Time: </span>
            </div>
            <div class="col-md-6">
                <span>{{ this.time }}</span>
            </div>
        </div>
        <div class="row mt-5">
            <div class="col-md-6">
                <h4 class="font-weight-bold">Before</h4>
                <div class="row mb-3" v-for="(value, index) in this.oldValues" :key="index">
                    <div class="col-md-4">
                        <span class="font-weight-bold">{{ index | formatLabel }} : </span>
                    </div>
                    <div class="col-md-8">
                        <div v-if="index == 'current_risk_state'">
                            <p class="m-0" v-for="risk in formatRisks(value)" :key="risk">
                                {{ risk }}
                            </p>
                        </div>
                        <span v-else>{{ value }}</span>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <h4 class="font-weight-bold">After</h4>
                <div class="row mb-3" v-for="(value, index) in this.newValues" :key="index">
                    <div class="col-md-4">
                        <span class="font-weight-bold">{{ index | formatLabel }} : </span>
                    </div>
                    <div class="col-md-8">
                        <div v-if="index == 'current_risk_state'">
                            <p class="m-0" v-for="risk in formatRisks(value)" :key="risk">
                                {{ risk }}
                            </p>
                        </div>
                        <span v-else>{{ value }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-md-12">
                <button class="btn btn-link" @click.prevent="back">Back</button>
            </div>
        </div>
    </div>
</template>

<script>
import RetailerHistoryService from '../../../services/RetailerHistoryService';

export default {
    data: function () {
        return {
            loading: false,
            date: '',
            time: '',
            oldValues: {},
            newValues: {}
        }
    },

    props: {
        id: {
            default: null,
        },
        retailerId: {
            default: null,
        },
    },

    mounted() {
        if(this.id) {
            this.load();
        }
    },

    filters: {
        formatLabel: function (text) {
            text = text.replace(/_/g, ' ');

            return text.charAt(0).toUpperCase() + text.slice(1);
        }
    },

    methods: {
        load: function () {
            this.loading = true;
            let params = {
                retailerId: this.retailerId
            };
            RetailerHistoryService.get(params, this.id)
                .then( ({data}) => {
                    this.date = data.data.date;
                    this.time = data.data.time;
                    this.oldValues = data.data.old_values;
                    this.newValues = data.data.new_values;
                    this.loading = false;
                });
        },

        formatRisks: function (risks) {
            if(risks == null) {
                return '';
            }
            let array = risks.split(',');

            return array;
        },

        back: function () {
            this.$router.go(-1);
        },
    }
}
</script>